export default __webpack_public_path__ + "c3bcb732c99d0866565acfefc5c6edd5.svg";